import axios from "axios";
import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import $ from "jquery";
import { Client_Search } from "../../Configuration/API_URL";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import {
  AESEncryption,
  ApiResDecrypt,
  OpenWindowWithPost,
} from "../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function PledgeReportSidebar() {
  const storeToken = localStorage.getItem("ssoToken");
  const [clientName, setClientName] = useState("");
  const [clientList, setClientList] = useState([]);
  const [clientCode, setClientCode] = useState("");
  const [scrollLoader, setScrollLoader] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [page, setPage] = useState(1);

  async function searchApiDetail(e) {
    $(".write-search.pledgeReport").addClass("show-result scroll-table");
    let payloadValue = {
      keyword: e.toUpperCase(),
      Status: "",
      PageNo: page,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      if (res.message === "Client does not exist.") {
        setClientList([
          { clientname: "Client does not exist.", clientCode: null },
        ]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.clients];
          });
        } else {
          setClientList(res.data.clients);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }
  const handleClientName = (e) => {
    setScrollLoader(false);
    if (e.target.value) {
      setClientList([]);
      setScroll(false);
      let result = e.target.value.toUpperCase();
      setClientName(result);
      if (e.target.value.length > 3) {
        setPage(1);
        setClientList([]);
        setScroll(false);
        searchApiDetail(e.target.value);
      }
    } else {
      setClientList([]);
      setPage(1);
      setClientName("");
      setScroll(false);
      $(".write-search.pledgeReport").removeClass("show-result");

      // searchApiDetail("")
    }
    $(".write-search.pledgeReport-li").click(function () {
      $(".write-search.pledgeReport").addClass("show-result scroll-table");
    });
  };
  function clientSet(name, code, i) {
    // document.querySelector("#input1").value = data.clientCode;
    if (name === "Client does not exist.") {
      $(".write-search.pledgeReport").addClass("show-result scroll-table");
    } else {
      $(".write-search.pledgeReport").removeClass("show-result");
      setClientList([]);
      setClientName(name);
      setClientCode(code);
    }
  }
  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector("#pledgeReportid-scroll");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setPage((prev) => prev + 1);
      setScrollLoader(true);
      // searchApiDetail(clientName);
    }
  };

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientName);
    }
  }, [page]);

  const handleOnClick = (e) => {
    if (clientName.length > 0) {
      if (clientCode) {
        window.open(
          `https://api.bajajfinservsecurities.in/api/dp/DietRequest/Pledge?UserID=${clientCode}${"&source=cosmos"}`
        );
        return;
      } else {
        toast.error("Please Select Name/Code");
      }
    } else {
      toast.error("Please Enter Client Name/Code");
    }
  };
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          {/* <div>
            <h2 className="report-title">Pledge</h2>
          </div> */}

          <div className="row input-field-wrapper">
            <div className="col-md-4 col-sm-6">
              <div className="form-group">
                <label className="form-label">{Constants.Client_Name}</label>
                <div className="input-text-wrapper align-items-center">
                  <input
                    id="input1"
                    type="text"
                    className="input-text form-control"
                    placeholder="Search by Name/ Code"
                    value={clientName}
                    // required
                    onChange={(e) => {
                      handleClientName(e);
                    }}
                  />

                  <ul
                    className="write-search pledgeReport border-0"
                    id="pledgeReportid-scroll"
                    onScroll={handleScroll}
                  >
                    {clientList.map((item, i) => (
                      <li
                        key={i}
                        onClick={() =>
                          clientSet(item.clientname, item.clientCode, i)
                        }
                      >
                        <div> {item.clientname}</div>
                        <div>{item.clientCode}</div>
                      </li>
                    ))}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              Pledge
            </button>
          </div>
        </div>
      </main>
    </>
  );
}

export default PledgeReportSidebar;
